import { Link } from "react-router-dom";
import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useContext,
} from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import "react-toastify/dist/ReactToastify.css";
import service from "../services/authservices";
import Tab from "react-bootstrap/Tab";
import { ScaleLoader } from "react-spinners";
import Tabs from "react-bootstrap/Tabs";
import { toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import authService from "../services/authservices";
import dayjs from "dayjs";
import { getUserDetails } from "../services/authservices";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";
const HistoryAll = () => {
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  useEffect(() => {
    if (i18nextLngs === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
    }
  }, [i18nextLngs]);

  const [loader, setLoader] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [currency, setCurrency] = useState("usdt");
  const [bottradeHistory, setbottradeHistory] = useState([]);
  const [limitwithadd, setLimitwithadd] = useState(10);
  const [currentPagebtrade, setCurrentPagebtrade] = useState(1);
  const [totalPagesbtrade, setTotalPagesbtrade] = useState(0);
  const [limitbtrade, setLimitbtrade] = useState(10);
  const coinTyperef = useRef(currency);
  useEffect(() => {
    fetchbottradeHistory(currentPagebtrade, limitbtrade);
  }, [currentPagebtrade, limitbtrade]);

  const handlePageChange = (event, value, eventName) => {
    switch (eventName) {
      case "Bot Trade":
        setCurrentPagebtrade(value);
        break;
      default:
        break;
    }
  };

  const handleCopy = (txID) => {
    if (handleCopy.toastVisible) return;

    handleCopy.toastVisible = true;

    if (handleCopy.timeout) clearTimeout(handleCopy.timeout);

    handleCopy.timeout = setTimeout(() => {
      navigator.clipboard
        .writeText(txID)
        .then(() => {
          toast.success(
            <div className="toast-ml">
              <h4 className="toast-title">Success!</h4>
              <p className="toast-message">
                Transaction ID copied to clipboard!
              </p>
            </div>
          );
        })
        .catch((err) => {
          // console.error("Failed to copy text: ", err);
          toast.error(
            <div className="toast-ml">
              <h4 className="toast-title">Error!</h4>
              <p className="toast-message">Failed to copy Transaction ID</p>
            </div>
          );
        })
        .finally(() => {
          setTimeout(() => {
            handleCopy.toastVisible = false;
          }, 2000);
        });
    }, 300); // 300ms debounce time
  };

  const fetchbottradeHistory = async (page, limit) => {
    setLoader(true);
    const response = await service.getBottradeHistory(page, limit);
    if (response.status) {
      setbottradeHistory(response.data);
      setTotalPagesbtrade(Math.ceil(response.total / limit));
      setLoader(false);
    } else {
      // console.error("Failed to fetch bot history:", response.Message);
      setLoader(false);
    }
  };

  const showErrorToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true); // Set toast as visible
      toast.error(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset toastVisible on close
          autoClose: 3000, // Optional: auto-close after 3 seconds
        }
      );
    }
  };

  const showSuccessToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true);
      toast.success(
        <div className="toast-ml">
          <h4 className="toast-title">Success!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset state on close
          autoClose: 3000, // Auto-close after 3 seconds
        }
      );
    }
  };

  return (
    <>
      <section>
        <Header />
      </section>

      <div className="withdraw-section">
        <div className="container">
          <div className="row prof_row_sm">
            <div className="col-lg-3 dispaly_none_1200">
              <Sidebar />
            </div>

            <div className="col-xl-9 col-lg-12 deposit_pad_top">
              <span className="profile_span">{t("BotTradeHistory")}</span>
              <div className="col-md-12 col-lg-12 verfication_kyc_col">
                <div className="pad-l-r">
                  <section className="asset_section asset_section_bottrade">
                    <>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="secuirty_box">
                            <div className="secuirty_box_contentsub deposit_contentsub">
                              <div className="table_section home_recent_table">
                                <div
                                  className="table_boxcontainer"
                                  style={{ height: "max-content" }}
                                >
                                  <table>
                                    <thead>
                                      <tr>
                                        <th>{t("Exchange")}</th>
                                        <th>{t("Currency")}</th>
                                        <th>{t("Profit")}</th>
                                        <th>{t("Strategy")}</th>
                                        <th>{t("Date&Time")}</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {loader ? (
                                        <tr>
                                          <td
                                            colSpan="5"
                                            style={{
                                              textAlign: "center",
                                              padding: "20px",
                                            }}
                                          >
                                            <div className="loader_main loader_mainChange">
                                              <ScaleLoader
                                                color="#20A1FD"
                                                height={10}
                                                width={3}
                                              />
                                              <p>{t("Loading")}</p>
                                            </div>
                                          </td>
                                        </tr>
                                      ) : bottradeHistory.length > 0 ? (
                                        bottradeHistory.map((ticket) => (
                                          <tr key={ticket._id}>
                                            <td>{ticket.exchange}</td>
                                            <td>{ticket.currency}</td>
                                            <td>{ticket.userProfit}</td>
                                            <td>{ticket.stratagy}</td>
                                            <td>
                                              {new Date(
                                                ticket.createdDate
                                              ).toLocaleString()}
                                            </td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan="5"
                                            style={{ textAlign: "center" }}
                                          >
                                            <span className="depo_no_record">
                                              {t("NoBotTradeFound")}
                                            </span>
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                  {totalPagesbtrade > 1 && (
                                    <div className="pagination history_pagination_all">
                                      <Stack spacing={2}>
                                        <Pagination
                                          count={totalPagesbtrade}
                                          page={currentPagebtrade}
                                          onChange={(e, value) =>
                                            handlePageChange(
                                              e,
                                              value,
                                              "Bot Trade"
                                            )
                                          }
                                          size="small"
                                          sx={{
                                            "& .MuiPaginationItem-root": {
                                              color: "#fff",
                                            },
                                            "& .Mui-selected": {
                                              backgroundColor:
                                                "#ffc630 !important",
                                              color: "#000",
                                              "&:hover": {
                                                backgroundColor: "#ffc630",
                                                color: "#000",
                                              },
                                            },
                                            "& .MuiPaginationItem-ellipsis": {
                                              color: "#fff",
                                            },
                                            "& .MuiPaginationItem-icon": {
                                              color: "#fff",
                                            },
                                          }}
                                        />
                                      </Stack>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HistoryAll;
